import { Box, Typography } from "@mui/material";
import { COLORS } from "assets";
import useTranslation from "hooks/useTranslation";

export default function NoDetectionModels() {
  const t = useTranslation();
  return (
    <Box
      role="status"
      sx={{
        width: "100%",
        border: `1px solid ${COLORS.surface.border}`,
        borderRadius: `${COLORS.radius.lg}px`,
        bgcolor: COLORS.surface.card,
        boxShadow: COLORS.shadow.card,
        px: 3,
        py: 3
      }}
    >
      <Typography sx={{ color: COLORS.surface.primaryText, fontWeight: 600, fontSize: 15 }}>
        {t["No detection models enabled"]}
      </Typography>
      <Typography sx={{ color: COLORS.surface.secondaryText, fontSize: 13, mt: 0.75, lineHeight: 1.5 }}>
        {t["No detection models enabled description"]}
      </Typography>
    </Box>
  );
}
